import { ComplianceStepType, useSetUserInfo } from '@ping/api';
import { useState } from 'react';
import { modalKeys } from '@ping/constants/modal-keys.constant';
import { t } from '@ping/helpers';
import { useRemoteModal } from '@ping/hooks';
import { Modal, Checkbox, ButtonA11Y } from '@ping/uikit';
import { importantNoticeModalRemoteStateSelector, useModalStore } from '@ping/stores/modal.store';
import { userInformationStore } from '@ping/stores/userInformation.store';

import style from './style.module.scss';

export const EntityTypeDeclarationModal = () => {
  const modal = useRemoteModal(modalKeys.ENTITY_TYPE_DECLARATION);
  const [isPersonalUseChecked, setIsPersonalUseChecked] = useState(false);
  const [isTermsAcceptedChecked, setIsTermsAcceptedChecked] = useState(false);
  const { mutate: userInfoMutate, isLoading: isUserInfoLoading } = useSetUserInfo();

  const importantNoticeModal = useModalStore(importantNoticeModalRemoteStateSelector);

  return (
    <Modal.Root {...modal.props}>
      <Modal.Portal
        className={style['entity-type-declaration-modal']}
        onOverlayPress={modal.state.open}
        isDismissable
        isKeyboardDismissDisabled
      >
        <Modal.Header className={style['entity-type-declaration-modal__header']}>
          <Modal.Title>{t('Accept terms')}</Modal.Title>
        </Modal.Header>
        <Modal.Content className={style['entity-type-declaration-modal__content']}>
          <p>{t('Please read and agree to the following terms before you continue.')}</p>

          <Checkbox
            name='PersonalUse'
            text={t(
              'I confirm that this account is for personal use only, and I understand that providing false or misleading information regarding the nature of this account information may result in termination and legal consequences.'
            )}
            checked={isPersonalUseChecked}
            onChange={() => setIsPersonalUseChecked(!isPersonalUseChecked)}
          />
          <Checkbox
            name='TermsAccepted'
            text={t(
              'The trading section of Ping Exchange is run by a AML registered Swiss Entity, while the custody is delegated to a Slovak and Bulgarian Entities.'
            )}
            checked={isTermsAcceptedChecked}
            onChange={() => setIsTermsAcceptedChecked(!isTermsAcceptedChecked)}
          />
        </Modal.Content>
        <Modal.Actions className={style['entity-type-declaration-modal__actions']}>
          <ButtonA11Y
            className={style['entity-type-declaration-modal__actions-button']}
            onPress={() => {
              userInfoMutate(
                {
                  data: {
                    entityType: true,
                    termsAccepted: true,
                  },
                },
                {
                  onSuccess: () => {
                    importantNoticeModal.open();
                    modal.state.close();
                    userInformationStore.setComplianceStep(ComplianceStepType.KycRequest);
                  },
                }
              );
            }}
            isDisabled={!isPersonalUseChecked || !isTermsAcceptedChecked || isUserInfoLoading}
            isLoading={isUserInfoLoading}
          >
            {t('Agree & Continue')}
          </ButtonA11Y>
        </Modal.Actions>
      </Modal.Portal>
    </Modal.Root>
  );
};
